<template>
  <div v-if="name === current">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'SlideRenderHelper',
  props: {
    name: String,
    current: String
  }
}
</script>
